import React, { useEffect, useRef, useState } from 'react';
import JsonEditor from '../../JsonEditor';
import Icon, { CloseOutlined } from '@ant-design/icons';
import EditSvg from '@icons/event-management/edit.svg';
import { Button, Input, Modal } from 'antd';
import { noop } from 'lodash';

const NewConfigBlock = ({ handleCreateNew, setOpenNewConfig, allConfig }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [openJsonEditor, setOpenJsonEditor] = useState(false);
  const [platform, setPlatform] = useState('');
  const [sensorVersion, setSensorVersion] = useState('');
  const [error, setError] = useState('');
  const newBlockRef = useRef(null);
  const [jsonData, setJsonData] = useState({});

  useEffect(() => {
    const { current }: any = newBlockRef;
    if (current) {
      current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [openJsonEditor]);

  const handleValidate = () => {
    if (!platform) {
      setError('Platform Can not be Empty');
      return;
    }
    if (
      allConfig.find(
        (config) =>
          config.platform === platform && config.sensor_version === (sensorVersion || 'nil'),
      )
    ) {
      setError('Config With same platform and version already exist');
      return;
    }
    if (!sensorVersion) setSensorVersion('nil');
    setError('');
    setIsModalOpen(false);
    setOpenJsonEditor(true);
  };

  const handleCancelValidate = () => {
    setOpenNewConfig(false);
  };

  const handleSave = (data) => {
    const payload = {
      platform: platform,
      sensor_version: sensorVersion,
      config: data.config,
    };
    setJsonData(data);
    handleCreateNew(payload);
  };

  return (
    <div>
      <Modal open={isModalOpen} onOk={handleValidate} onCancel={handleCancelValidate}>
        Platform: *
        <Input placeholder="Enter Platform" onChange={(e) => setPlatform(e.target.value)} />
        Sensor Version:
        <Input
          placeholder="Enter Platform Version"
          onChange={(e) => setSensorVersion(e.target.value)}
        />
        <div style={{ color: 'red' }}>{error}</div>
      </Modal>

      <div style={{ padding: '10px 16px 10px' }}>
        <div style={{ display: 'flex', gap: '5px' }}>
          <div style={{ display: 'flex', minWidth: 180 }}>
            {'<'}
            <Icon component={EditSvg} style={{ fontSize: 'smaller' }} />
            {'> '}
            {`${platform}_${sensorVersion}`}
          </div>
          <Button
            size={'small'}
            onClick={() => {
              setOpenJsonEditor(!openJsonEditor);
            }}
          >
            {openJsonEditor ? 'Close' : 'Open'} Editor
          </Button>
          {openJsonEditor && (
            <Button
              size="small"
              danger
              icon={<CloseOutlined />}
              onClick={() => setOpenNewConfig(false)}
            >
              Discard
            </Button>
          )}
        </div>
        {openJsonEditor && (
          <div style={{ padding: '0 16px' }} ref={newBlockRef}>
            <JsonEditor
              data={jsonData}
              refetch={noop}
              handleSave={handleSave}
              height={'430px'}
              showDelete={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default NewConfigBlock;
